module.exports = __webpack_public_path__ + "static/media/dualMsg.2101b61e.svg";